(() => {
  if (!document.querySelector(".lp-tabios_cotton")) return;
$(function () {
	$('.menu-trigger-box').on('click', function () {
		$(this).toggleClass('active');
		$('.menu-trigger').toggleClass('active');
		if($('.hamburger').hasClass('active')){
			$('.hamburger').addClass('close');
			$(".hamburger").removeClass("active");
		}else {
			$('.hamburger').toggleClass('active');
			$(".hamburger").removeClass("close");
		}
	});

	$('#hamburger_feature').hover(
		function (){
			$(".pointer").css({transform: "translateY(67px)"});
		},
		function () {
			$(".pointer").css({transform: "translateY(0)"});
		}
	);
	$('#hamburger_creator').hover(
		function (){
			$(".pointer").css({transform: "translateY(134px)"});
		},
		function () {
			$(".pointer").css({transform: "translateY(0)"});
		}
	);
	$('#hamburger_lineup').hover(
		function (){
			$(".pointer").css({transform: "translateY(201px)"});
		},
		function () {
			$(".pointer").css({transform: "translateY(0)"});
		}
	);
	
	$('.hamburger_list_item_link').on('click', function () {
		$('.menu-trigger').removeClass('active');
		$('.hamburger').removeClass('active');
 });
	
	jQuery(function(){
		jQuery('a[href^="#"]').click(function(){
		var speed = 700;
		var href= jQuery(this).attr("href");
		var target = jQuery(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		jQuery("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
		});
	});
	
});

$(window).on("load scroll", function () {
		var mainHeight = $(".main_image").offset();
    if (3000 < mainHeight.top) {
        $(".main_image").css('opacity',0);
    }
    else {
        $(".main_image").css('opacity',1);
    }
	});



	setTimeout(function(){
    var v = document.getElementById('videokey');
			v.play();
		},3000);
	setTimeout(function(){
    var v = document.getElementById('videokey_sp');
			v.play();
		},3000);
	
	$(function() {
      setTimeout(function() {
        $('.loader_logo').fadeIn(1500);
      }, 300);
      setTimeout(function() {
        $('.loader_logo').fadeOut(1000);
      }, 2000);
      setTimeout(function() {
        $('.logo_loader').fadeOut(1000);
      }, 3200);
    });
	
	document.querySelectorAll(".filter_blur").forEach((el, index) => {
	    ScrollTrigger.create({
	        trigger: el,
	        id: index+1,
	        start: 'top 85%',
	        toggleClass: {targets: el, className: "filter_blur_none"},
					once: true,
	    });
	});
	
	document.querySelectorAll(".title_animation").forEach((el, index) => {
	    ScrollTrigger.create({
	        trigger: el,
	        id: index+1,
	        start: 'top bottom',
	        toggleClass: {targets: el, className: "active"},
					once: true,
	    });
	});
	
	gsap.utils.toArray(".fade_animation").forEach(target => {
    gsap.from(target, {
      scrollTrigger: {
        trigger: target,
      },
			y: 20,
      alpha: 0,
			delay: .7,
			duration: 1.3,
    });
  });
	
	gsap.utils.toArray(".fade_animation2").forEach(target => {
    gsap.from(target, {
      scrollTrigger: {
        trigger: target,
      },
      alpha: 0,
			delay: .3,
			duration: 1.2,
    });
  });
	
	gsap.utils.toArray(".fadeup_animation").forEach(target => {
    gsap.from(target, {
      scrollTrigger: {
        trigger: target,
      },
			y: 20,
      alpha: 0,
			duration: 1,
			delay: .3,
    });
  });
	
	gsap.fromTo(
		".feature1_img1",
		{
			yPercent: 0,
		},
		{
			yPercent: 20,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature1_img1",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature1_img2",
		{
			yPercent: 0,
		},
		{
			yPercent: -20,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature1_img2",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature1_img3",
		{
			yPercent: 0,
		},
		{
			yPercent: -25,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature1_img3",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature2_img1",
		{
			yPercent: 0,
		},
		{
			yPercent: 20,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature2_img1",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature2_img2",
		{
			yPercent: 0,
		},
		{
			yPercent: -45,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature2_img2",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature3_img1",
		{
			yPercent: 0,
		},
		{
			yPercent: -30,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature3_img1",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature3_img2",
		{
			yPercent: 0,
		},
		{
			yPercent: -45,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature3_img2",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature4_img1",
		{
			yPercent: 0,
		},
		{
			yPercent: -30,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature4_img1",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature4_img2",
		{
			yPercent: 0,
		},
		{
			yPercent: -45,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature4_img2",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature5_img1",
		{
			yPercent: 0,
		},
		{
			yPercent: -20,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature5_img1",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature5_img2",
		{
			yPercent: 0,
		},
		{
			yPercent: -20,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature5_img2",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature5_img3",
		{
			yPercent: 0,
		},
		{
			yPercent: -10,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature5_img3",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature6_img1",
		{
			yPercent: 0,
		},
		{
			yPercent: -40,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature6_img1",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature6_img2",
		{
			yPercent: 0,
		},
		{
			yPercent: -45,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature6_img2",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature6_img3",
		{
			yPercent: 0,
		},
		{
			yPercent: -20,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature6_img3",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	gsap.fromTo(
		".feature6_img4",
		{
			yPercent: 0,
		},
		{
			yPercent: -30,
			ease: "none",
			scrollTrigger: {
				trigger: ".feature6_img4",
				start: "top bottom",
				end: "bottom top",
				scrub: 2,
			},
		}
	);
	
	
	
	gsap.from(".creator_box_title_span", {
		scrollTrigger: {
			trigger: ".creator_box_title",
		},
		y: 10,
		stagger: 0.05,
		delay: 0.2,
		duration: 0.5,
		alpha: 0,
});
	
	gsap.from(".section_lineup_title_span", {
		scrollTrigger: {
			trigger: ".section_lineup_title",
		},
		y: 10,
		stagger: 0.05,
		delay: 0.2,
		duration: 0.5,
		alpha: 0,
});
	
	gsap.to(".cover_left", .8,{
		scrollTrigger: {
			trigger: ".lineup_box",
		},
		left: '100%',
		delay: .5,
		ease: Expo.ease
	});
	gsap.to(".cover_right", .8,{
		scrollTrigger: {
			trigger: ".lineup_box",
		},
		right: '100%',
		delay: .5,
		ease: Expo.ease
	});
	gsap.to(".cover_top", .8,{
		scrollTrigger: {
			trigger: ".lineup_box",
		},
		top: '100%',
		delay: .5,
		ease: Expo.ease
	});
	gsap.to(".cover_bottom", .8,{
		scrollTrigger: {
			trigger: ".lineup_box",
		},
		bottom: '100%',
		delay: .5,
		ease: Expo.ease
	});
	


})();
